// import queryString from "query-string";
import React, { useContext } from "react";
import {
  CustomButton2,
  CustomDropdownFilter,
  CustomDropdownSearch,
  CustomView,
  //   CustomRadioButtonGroup,
  //   DropDownSearchCities,
  //   DropDownSearchProvinces,
  //   DropDownSearchSuperAgent,
} from "../../../../components";
import Cookies from "js-cookie";
import constants from "../../../../values/constants";
import "./index.scss";
import { useQuery } from "react-query";
import api from "../../../../api";
import values from "../../../../values";
import Context from "../../../../context";
import {
  ICityItem,
  ICompanyItem,
  IItem,
  IProvinceItem,
} from "../../../../types/common.interface";
import utils from "../../../../utils";
import { useTranslation } from "react-i18next";

const FilterAgent = () => {
  // ============================== Value Validation ================================

  //   const {search} = queryString.parse(window.location.search);
  const [selectedFilters, setSelectedFilters] = React.useState<any>({
    // isBlock,
    // isApproved,
    // province,
    // city,
  });

  const { requestParent, setRequestParent } = useContext(Context.ParentScreen);
  const userType = utils.stringHexConversion.reverse(
    Cookies.get(constants.USER.TYPE)
  );

  // !! ===========================================================================================================
  // !!                                            Start API Call
  // !! -----------------------------------------------------------------------------------------------------------
  const getAllProvince = useQuery([values.useQueryKeys.getAllProvince], () =>
    api.get.common.getAllProvince()
  );
  const getAllCity = useQuery(
    [values.useQueryKeys.getAllCity, requestParent?.filters?.province],
    () =>
      api.get.common.getAllCity({
        provinceCode: requestParent?.filters?.province?.Code,
      })
  );

  // !! -----------------------------------------------------------------------------------------------------------
  // !!                                             End API Call
  // !! ===========================================================================================================

  const { t } = useTranslation();

  // ================================ UseEffect Call ===============================

  // ================================== JSX Content ================================

  return (
    <div className="filter-container">
      <CustomDropdownFilter title={t("filter")}>
        <CustomView.Container>
          <CustomView.Row>
            {(userType === "ADMIN" || userType === "COMPANY") && (
              <>
                <p className="filter-labels">{t("province")}:</p>
                <CustomDropdownSearch
                  items={getAllProvince?.data?.result}
                  itemName="Name"
                  defaultItem={requestParent?.filters?.province}
                  onSelectItem={(event: IProvinceItem) =>
                    setRequestParent!({
                      ...requestParent,
                      filters: {
                        ...requestParent?.filters,
                        province: event,
                        city: undefined,
                      },
                    })
                  }
                  placeHolder={t("selectProvince")}
                  isLoading={getAllProvince.isLoading}
                />
                <p className="filter-labels">{t("city")}:</p>
                <CustomDropdownSearch
                  items={getAllCity?.data?.result}
                  itemName="Name"
                  defaultItem={requestParent?.filters?.city}
                  onSelectItem={(event: ICityItem) =>
                    setRequestParent!({
                      ...requestParent,
                      filters: {
                        ...requestParent?.filters,
                        city: event,
                      },
                    })
                  }
                  placeHolder={t("selectCity")}
                  isLoading={getAllCity.isLoading}
                />
              </>
            )}
            <p className="filter-labels">{t("gender")}:</p>
            <CustomDropdownSearch
              items={gender.map((item) => {
                return { ...item, name: t(item?.name as string) };
              })}
              itemName="name"
              placeHolder={t("selectGender")}
              defaultItem={
                requestParent?.filters?.gender?.value
                  ? {
                      value: requestParent?.filters?.gender.value,
                      name: t(requestParent?.filters?.gender.name),
                    }
                  : undefined
              }
              onSelectItem={(event: ICompanyItem) =>
                setRequestParent!({
                  ...requestParent,
                  filters: {
                    ...requestParent?.filters,
                    gender: event,
                  },
                })
              }
            />
          </CustomView.Row>
        </CustomView.Container>
        <div className="filter-footer">
          <CustomButton2
            title={t("reset")}
            onClick={() => {
              setRequestParent({
                limit: values.constants.PANEL_TABLE_DEFAULT_LIMIT,
                page: 1,
              });
            }}
            type="primary"
          />
        </div>
      </CustomDropdownFilter>
    </div>
  );
};

const gender: IItem[] = [
  { name: "male", value: "MALE" },
  { name: "feMale", value: "FEMALE" },
];
export default FilterAgent;
